import { render, staticRenderFns } from "./network-matriz.vue?vue&type=template&id=4ed6fa74&scoped=true"
import script from "./network-matriz.vue?vue&type=script&lang=js"
export * from "./network-matriz.vue?vue&type=script&lang=js"
import style0 from "./network-matriz.vue?vue&type=style&index=0&id=4ed6fa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6fa74",
  null
  
)

export default component.exports